import { EnvironmentTypeAccess } from "Api/organizations/member/projectAccess/ProjectAccess.types";

export const transformTeamPermissions = (
  permissions: Array<EnvironmentTypeAccess>
) =>
  permissions.includes("admin")
    ? [["project", "admin"]]
    : permissions
        .filter(permission => permission !== "viewer")
        .map(permission =>
          permission === "admin" ? "project:admin" : permission
        )
        .map(permission => permission.split(":"));
